import cx from "classnames";
import React from "react";
import styles from "./CreditHoursBadge.module.css";

type BadgeSize = "lg" | "sm";

const DEFAULT_SIZE = "lg";

type BadgeProps = {
  ceUnits?: number;
  size?: BadgeSize;
};

const CreditHoursBadge = ({ ceUnits, size = DEFAULT_SIZE }: BadgeProps) => (
  <div className={cx(styles.root, styles[size])}>
    <div>
      <div className={styles.ceWrapper}>{ceUnits} CE</div>
      <div className={styles.creditsWrapper}>{ceUnits === 1 ? "credit" : "credits"}</div>
    </div>
  </div>
);

export default CreditHoursBadge;
